import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptionStack, OptionSubGroup } from '@modules/menu/components';
import { Option } from '../../../../interfaces/option.interface';
import { OptionGroup } from '../../../../interfaces/option-group.interface';
import { AccessibilityService } from '@modules/menu/services';

@Component({
  selector: 'app-half-and-half-selector',
  templateUrl: './half-and-half-selector.component.html',
  styleUrls: ['half-and-half-selector.component.scss'],
})
export class HalfAndHalfSelectorComponent implements OnInit {
  @Input() optionGroup: OptionGroup;
  @Input() optionSubGroup: OptionSubGroup;
  @Input() selectedOptionIndex: number;
  @Output() optionClick = new EventEmitter<Option>();
  @Output() subOptionClick = new EventEmitter<OptionStack>();
  selectedOption: Option;
  selectedSubOption: Option;

  constructor(private a11yService: AccessibilityService) {}

  ngOnInit() {
    if (this.selectedOptionIndex !== undefined) {
      this.selectedOption = this.optionGroup.options[this.selectedOptionIndex];
    } else {
      this.selectedOption = this.optionGroup.options[1]; // Default to whole pizza
      this.optionClicked(this.selectedOption);
    }
  }

  optionClicked(option: Option) {
    const prevOption = this.selectedOption;
    this.selectedOption = option;
    if (option) {
      this.optionClick.emit(option);

      // Announce the selection to screen readers
      let sideName = '';
      if (option.name.includes('Left')) {
        sideName = 'Left half only';
      } else if (option.name.includes('Right')) {
        sideName = 'Right half only';
      } else {
        sideName = 'Whole pizza';
      }

      if (prevOption !== option) {
        this.a11yService.announce(`Selected ${sideName} for this topping`, 'assertive');
      }
    }
  }

  subOptionClicked(option: Option) {
    const prevOption = this.selectedSubOption;
    this.selectedSubOption = option;
    if (option) {
      this.subOptionClick.emit({
        option,
        optionGroup: this.optionGroup,
        subOptionGroup: this.optionSubGroup,
      });

      // Announce the selection to screen readers
      let sideName = '';
      if (option.name.includes('Left')) {
        sideName = 'Left half only';
      } else if (option.name.includes('Right')) {
        sideName = 'Right half only';
      } else {
        sideName = 'Whole pizza';
      }

      if (prevOption !== option) {
        this.a11yService.announce(`Selected ${sideName} for this topping`, 'assertive');
      }
    }
  }

  getAccessibleSideLabel(option: Option): string {
    if (option.name.includes('Left')) {
      return 'Left half only';
    } else if (option.name.includes('Right')) {
      return 'Right half only';
    } else {
      return 'Whole pizza';
    }
  }
}
